<template>
  <div class="list-wrapper">
   <div class="offcbg" :dataLoad = currentIndex>
            <!--活动开始-->
            <div class="offcnhd">
               
                <a class="zhichi"></a>
                <a class="a2"></a>
                <a class="a3"></a>
            </div>
            <!--活动结束-->
            <!--直播公开课开始-->
            <div class="offcnLive" style="display: ;">
                <div class="offcnLive_center">
                    <div class="offcn_title">
                        <b>
                            直播公开课
                            <img src="https://statics.eoffcn.com/statics/newIndexImg/h5/js1.png">
                        </b>
                    </div>
                    <div class="offcnLive_center_c">
                    </div>
                </div>
            </div>
            <!--直播公开课结束-->
            <!--师资开始-->
            <div class="offcnTeachers">
                <div class="offcnTeachers_center">
                    <div class="offcn_title offcn_titlehd">
                        <b>
                            网校师资
                            <img src="https://statics.eoffcn.com/statics/newIndexImg/h5/hot.png">
                        </b>
                    </div>
                    <div class="offcnTeachers_tab">
                        <div class="offcnTeachers_sw">
                            <div class="swiper-wrapper">
                            </div>
                            <div class="offcnTeachers_pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!--师资结束-->
            <!--会员开始-->
            <div class="offcnNewMemberPoster">
                <div class="offcnNewMemberPoster_center">
                    <div class="offcnNewMemberPoster_title">
                        <img class="huiyuan" src="https://statics.eoffcn.com/statics/newIndexImg/h5/hy.png">
                        <p>网校精选好课畅学\1折购课\每日干货\行业分析\就业指导\专属顾问</p>
                        <div>
                            <a class="a1" href="https://docs.qq.com/doc/DT0lIblBWYnROVEZt" target="_blank">免费领取</a>
                            <a class="a2">
                                <b>最低42/年</b>立即开通
                            </a>
                        </div>
                    </div>
                    <div class="offcnNewMemberPoster_nav">
                        <div class="offcnNewMemberPoster_hover offcnNewMemberPoster_nav_t">
                            <div class="div1">
                                <div>
                                </div>
                                <a class="mored">
                                    <!-- mores -->
                                </a>
                            </div>
                            <div class="div2">
                            </div>
                        </div>
                        <div class="offcnNewMemberPoster_hover offcnNewMemberPoster_nav_ts">
                            <div class="div1">
                                <div>
                                </div>
                                
                                <a class="mored">更多<b></b>
                                    <!-- mores -->
                                </a>
                            </div>
                            <div class="div2">
                            </div>
                        </div>
                        
                        <div class="offcnNewMemberPoster_tab">
                            <div class="offcnNewMemberPoster_tabs">
                                <strong>会员免费专区</strong>
                                <div class="offcnNewMemberPoster_ceb">
                                </div>
                            </div>
                            <div class="offcnNewMemberPoster_tabs">
                                <strong>会员特惠专区</strong>
                                <div class="offcnNewMemberPoster_ceb">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--会员结束-->
            <div class="offcnCourseh5" style="display:none;">
                <div class="offcnCourseh5_left">
                    <div class="offcnCourseh5_height">
                        <div class="swiper-wrapper">
                            <!-- <span class="swiper-slide">公务员<i></i></span> -->
                        </div>
                    </div>
                </div>
                <div class="offcnCourseh5_right">
                    <div class="offcnCourseh5_nav">
                        <div class="offcnCourseh5_fx">
                            <div class="swiper-wrapper">
                                <!-- <span class="swiper-slide">公务员<i></i></span> -->
                            </div>
                        </div>
                    </div>
                    <div class="onRecord">加载中...</div>
                    <div class="offcnCourseh5_center">
                     
                    </div>
                </div>

            </div>
   
    </div>
  </div>
</template>
<script>
  import CupidStyle1 from '../../utils/record.js'
  import CupidStyle2 from '../../../static/js/CupidStyle/js/jquery.js'
  import CupidStyle3 from '../../../static/js/CupidStyle/js/swiper.js'
  import {onLoads} from '../../../static/js/CupidStyle/js/pubilc.js'
  export default {
     props: {
      currentIndex: Number,
      numberGoodsId: Number
    },
    data () {
      return {}
    },
    mounted () {
        onLoads(this.$props.numberGoodsId)
      console.log(this.$props.currentIndex, "$attrs.message")
      console.log(this.$props.numberGoodsId, "$attrs.message")
      console.log(this.$props, "$attrs.message")
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/moreCourses/index.vue